import { useState, useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { use } from '../Helpers'
import { call } from '../Methods'
import Input from './Input'

function CommandForm ({ name, parameters, warning = '', onSubmit }) {
  const commandTypes = [
    {
      commandGroupName: 'ModalCommands',
      commands: [
        {
          name: 'candidateToStudent',
          title: 'Yeni iştirakçı',
          enabled: true,
          description:
            'Müraciət zamanı iştirakçı namizədi kimi qeydiyyata alınmış məktəblinin daha öncə yaradılmış bir qrupa əlavə edilərək iştirakçı kimi qeydiyyata alınması üçün',
          action: parameters =>
            call.forLoggedUser.student.createFromCandidate(parameters),
          parameterFields: [
            {
              label: 'Namizəd',
              type: 'select',
              //disabled:true,
              fieldName: 'id',
              col: { sm: 12 },
              validationRules: ['required'],
              dataSource: async () => {
                const source = await call.forLoggedUser.candidate.getCandidates(
                  {}
                )
                return source.data
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map(d => {
                    return { value: d.id, text: d.name + ' ' + d.surname }
                  })
              }
            },
            {
              label: 'Qrup',
              type: 'select',
              fieldName: 'groupId',
              col: { sm: 12 },
              validationRules: ['required'],
              dataSource: async () => {
                const source = await call.forLoggedUser.group.getGroups({
                  statusIds: '0,1'
                })
                return source.data.map(d => {
                  return {
                    value: d.id,
                    text: `${d.name} - ${
                      d.courseName
                    } - ${use.convertDatetimeToShortDate(d.startDate)}`
                  }
                })
              }
            }
          ]
        },
        {
          name: 'addDeposit',
          title: 'Depozit məbləği əlavə et',
          enabled: true,
          description: '',
          action: parameters =>
            call.forLoggedUser.payment.addPayment(parameters),
          parameterFields: [
            {
              label: 'Namizəd',
              type: 'select',
              //disabled:true,
              fieldName: 'studentId',
              col: { sm: 12 },
              validationRules: ['required'],
              dataSource: async () => {
                const source =
                  await call.forLoggedUser.candidate.getCandidateById({
                    id: parameters.id
                  })
                return [
                  {
                    value: source.data.id,
                    text: source.data.name + ' ' + source.data.surname
                  }
                ]
              }
            },
            {
              label: 'Ödəniş tipi',
              type: 'select',
              fieldName: 'paymentTypeId',
              col: { sm: 12 },
              validationRules: ['required'],
              dataSource: async () => {
                const source =
                  await call.forLoggedUser.listOption.getListOptions({
                    listName: 'PaymentType'
                  })
                let data = source.data.map(d => {
                  return { value: d.value, text: d.text, selected: false }
                })
                return data
              }
            },
            {
              label: 'Məbləğ',
              type: 'number',
              fieldName: 'amount',
              col: { sm: 12 },
              validationRules: ['required']
            },
            {
              label: '',
              type: 'hidden',
              fieldName: 'statusId',
              validationRules: ['required'],
              defaultValue: 3
            }
          ]
        },
        {
          name: 'studentMoveToGroup',
          title: 'Qrupa əlavə et',
          enabled: true,
          description: 'Təsdiqlənmiş iştirakçını qrupa əlavə et',
          action: parameters =>
            call.forLoggedUser.student.moveToGroup(parameters),
          parameterFields: [
            {
              label: 'İştirakçı',
              type: 'select',
              //disabled:true,
              fieldName: 'studentId',
              col: { sm: 12 },
              validationRules: ['required'],
              dataSource: async () => {
                const source = await call.forLoggedUser.student.getStudentById({
                  id: parameters.studentId
                })
                return [
                  {
                    value: source.data.id,
                    text: source.data.name + ' ' + source.data.surname
                  }
                ]
              }
            },
            {
              label: 'Qrup',
              type: 'select',
              fieldName: 'groupId',
              col: { sm: 12 },
              validationRules: ['required'],
              dataSource: async () => {
                const source = await call.forLoggedUser.group.getGroups({
                  statusIds: '0,1'
                })
                let data = source.data.map(d => {
                  return {
                    value: d.id,
                    text: `${d.name} - ${
                      d.courseName
                    } - ${use.convertDatetimeToShortDate(d.startDate)}`
                  }
                })
                return data
              }
            }
          ]
        },
        {
          name: 'addToGroup',
          title: parameters?.id ? 'Qrupa daxil et':'Yeni iştirakçı',
          enabled: true,
          description:
            'İştirakçı məlumatları əlavə olunduqdan sonra onu davam edən qruplardan birinə əlavə etmək üçün bu komanda işə salınmalıdır.',
          action: parameters =>
            call.forLoggedUser.student.moveToGroup(parameters),
          parameterFields: [
            {
              label: 'Namizəd',
              type: 'select',
              disabled:parameters?.id?true:false,
              fieldName: 'id',
              col: { sm: 12 },
              validationRules: ['required'],
              dataSource: async () => {
                const source = await call.forLoggedUser.candidate.getCandidates({
                  id: parameters?.id
                })
                return source.data?.map(d => {
                  return {
                    value: d.id,
                    text: `${d.name} ${d.surname} - ${d.requesterFullName}`
                  }
                })
              }
            },
            {
              label: 'Qrup',
              type: 'select',
              fieldName: 'groupId',
              col: { sm: 12 },
              validationRules: ['required'],
              dataSource: async () => {
                const source = await call.forLoggedUser.group.getGroups({
                  statusIds: '0,1'
                })
                let data = source.data.map(d => {
                  return {
                    value: d.id,
                    text: `${d.name} - ${
                      d.courseName
                    } - ${use.convertDatetimeToShortDate(d.startDate)}`
                  }
                })
                return data
              }
            }
          ]
        },
        {
          name: 'groupTransfer',
          title: 'Transfer',
          enabled: true,
          warning:
            'İştirakçı digər qrupa keçdikdən sonra bu qrup üzrə heç bir əməliyyat apara bilməyəcək.',
          description:
            'Müraciət zamanı iştirakçı namizədi kimi qeydiyyata alınmış məktəblinin daha öncə yaradılmış bir qrupa əlavə edilərək iştirakçı kimi qeydiyyata alınması üçün',
          action: parameters =>
            call.forLoggedUser.student.transferToGroup(parameters),
          parameterFields: [
            {
              label: '',
              fieldName: 'id', //studentGroupId
              type: 'hidden',
              defaultValue: parameters?.id,
              validationRules: ['required']
            },
            {
              label: 'İştirakçının adı',
              type: 'text',
              fieldName: 'studentFullName',
              disabled: true,
              defaultValue: parameters?.studentFullName,
              col: { sm: 12 }
            },
            {
              label: 'Qrup',
              type: 'select',
              fieldName: 'groupId',
              col: { sm: 12 },
              validationRules: ['required'],
              dataSource: async () => {
                const source = await call.forLoggedUser.group.getGroups({
                  statusIds: '0,1'
                })
                let data = source.data
                  .filter(g => g.id != parameters?.groupId)
                  .map(d => {
                    return {
                      value: d.id,
                      text: `${d.name} - ${
                        d.courseName
                      } - ${use.convertDatetimeToShortDate(d.startDate)}`
                    }
                  })
                return data
              }
            },
            {
              label: 'Ödənişləri də yeni qrupa transfer et',
              type: 'checkbox',
              fieldName: 'paymentTransfer',
              col: { sm: 12 }
            },
            {
              label: 'Açıqlama',
              placeholder: 'Transferin səbəbini izah edin',
              type: 'textarea',
              fieldName: 'leaveReason',
              col: { sm: 12 }
            }
          ]
        },
        {
          name: 'delete',
          title: 'Diqqət!',
          submitText: 'Təsdiq',
          enabled: true,
          action: () => {
            if (parameters.entity) {
              let actionName =
                'delete' +
                parameters.entity[0].toUpperCase() +
                parameters.entity.slice(1)
              return call.forLoggedUser[parameters.entity][actionName]({
                id: parameters.id
              })
            }
          },
          parameterFields: [
            {
              label: '',
              type: 'readonly-text',
              defaultValue: (
                <span className='command-warning'>
                  {warning == 'undefined'
                    ? 'Qeydi silmək istədiyinizə əminsinizmi?'
                    : warning}
                </span>
              ),
              fieldName: '',
              col: { sm: 12 }
            }
          ]
        }
      ]
    }
  ]
  const [commandTitle, setCommandTitle] = useState(
    commandTypes
      .map(ct => ct.commands)
      .flat()
      .find(c => c.name == name)?.title
  )
  document.title = `${commandTitle} | ${process.env.REACT_APP_NAME}`
  const [activeCommand, setActiveCommand] = useState({})
  const [loading, setLoading] = useState(false)
  const { pathname } = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (!(undefined, null, '').includes(name)) {
      console.log(name, parameters)
      commandTypes
        .map(a => a.commands)
        .flat()
        .forEach(_cmd => {
          if (_cmd.name == name) {
            console.log(_cmd)
            setActiveCommand(_cmd)
            return
          }
        })
    }
  }, [name, parameters])

  const collectFormData = () => {
    let data = {}
    activeCommand.parameterFields.forEach(f => {
      if (
        f.type != 'readonly-text' &&
        f.fieldName != undefined &&
        !f.disabled
      ) {
        data[f.fieldName] = use.getInputValueByName(f.fieldName)
      }
    })
    return data
  }

  const renderCommandParameterFields = () => {
    if (activeCommand)
      return (
        <>
          <form
            className='command-form row'
            name={activeCommand.title}
            onSubmit={e => submitForm(e)}
          >
            {activeCommand?.parameterFields?.map((field, index) => {
              return (
                <Input
                  key={`${field.fieldName}#${index}`}
                  fieldName={field.fieldName}
                  disabled={field.disabled || loading}
                  label={field.label}
                  placeholder={field.placeholder}
                  type={field.type}
                  defaultSelectOptions={field.defaultSelectOptions}
                  col={field.col}
                  acceptNullValue={field.acceptNullValue}
                  data={field.dataSource ? null : field.data}
                  dataSource={field.dataSource}
                  value={field.defaultValue}
                  eventHandler={field.eventHandlers}
                />
              )
            })}
            <Input
              label={`${
                loading
                  ? 'Gözləyin...'
                  : activeCommand.submitText || 'Tətbiq et'
              }`}
              type='submit'
              disabled={loading}
              style={{ margin: '15px 0px 0px', padding: '7px 0' }}
            />
          </form>
        </>
      )
  }

  const submitForm = async e => {
    setLoading(true)
    e.preventDefault()
    const data = collectFormData()
    const result = await activeCommand.action(data)
    if (result.success) {
      alert('Uğurla tətbiq olundu.')
      setTimeout(() => {
        setLoading(false)
        closeCommandModal()
        onSubmit()
      }, 1000)
    } else {
      setLoading(false)
      alert('Xəta baş verdi')
    }
  }

  const closeCommandModal = () => {
    setActiveCommand(null)
    navigate(pathname, { replace: true })
  }

  return (
    <div className={`command-modal-container ${activeCommand ? 'open' : ''}`}>
      <div className='command-modal'>
        <div className='header'>
          <h3 className='heading'>{activeCommand?.title}</h3>
          <span className='close' onClick={() => closeCommandModal()}>
            &times;
          </span>
        </div>
        {activeCommand && renderCommandParameterFields()}
      </div>
    </div>
  )
}

export default CommandForm
